import { queryOptions } from '@tanstack/react-query';
import { reviewApi } from './review.api';
import { STALE_TIME } from '@/lib/query/stale-times';

export {
  registrationQueries as reviewContainerQueries,
  registrationKeys as reviewContainerKeys
} from '@/features/registration';

export const reviewKeys = {
  all: ['review'] as const,
  metrics: () => [...reviewKeys.all, 'metrics'] as const,
  activities: (registrationId: number) =>
    [...reviewKeys.all, 'activities', registrationId] as const
};

export const reviewQueries = {
  metrics: () =>
    queryOptions({
      queryKey: reviewKeys.metrics(),
      queryFn: () => reviewApi.getMetrics(),
      staleTime: STALE_TIME.metrics
    }),

  activities: (registrationId: number) =>
    queryOptions({
      queryKey: reviewKeys.activities(registrationId),
      queryFn: () => reviewApi.getActivities(registrationId),
      enabled: registrationId > 0
    })
};
